@if(informacionFichaRegistro$ | async; as ficha){
  <div  class="flex w-full flex-col">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 w-full justify-start items-stretch">
      <div class="border border-gray-300 h-full">
        <div class="flex flex-row border border-gray-300 items-center justify-center">
          <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >EPOCA</label>
          <input type="text" name="epoca" [(ngModel)]="procedencia.epoca" id="epoca" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border border-gray-300 items-center justify-center">
          <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >PERIODO</label>
          <input type="text" name="periodo" id="periodo" [(ngModel)]="procedencia.periodo" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border border-gray-300 items-center justify-center">
          <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >FASE</label>
          <input type="text" name="fase" id="fase" [(ngModel)]="procedencia.fase" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border border-gray-300 items-center justify-center">
          <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >AÑO</label>
          <input type="text" name="anio" id="anio" [(ngModel)]="procedencia.anio" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
                >ESTILO/TIPO</label>
            <input type="text" name="tipoEstilo" id="tipoEstilo" [(ngModel)]="procedencia.tipoEstilo" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
                >PROCEDENCIA</label>
            <input type="text" name="procedencia" id="procedencia" [(ngModel)]="procedencia.procedencia" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border border-gray-300 items-center justify-center">
            <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
                >FORMA DE ADQUISICION</label>
            <input type="text" name="adquisicion" id="adquisicion" [(ngModel)]="procedencia.formaAdquisicion" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>
        <div class="flex flex-row border border-gray-300 items-center justify-center">
          <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >TRADICION</label>
          <input type="text" name="tradicion" id="tradicion" [(ngModel)]="procedencia.tradicion" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border border-gray-300 items-center justify-center">
          <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >AUTOR</label>
          <input type="text" name="autor" id="autor" [(ngModel)]="procedencia.autor" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border border-gray-300 items-center justify-center">
          <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >CONSTRUCTOR</label>
          <input type="text" name="constructor" id="constructor" [(ngModel)]="procedencia.constructorTexto" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border border-gray-300 items-center justify-center">
          <label class="w-1/2 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >INFORMANTE</label>
          <input type="text" name="informante" id="informante" [(ngModel)]="procedencia.informante" class="w-1/2 md:w-9/12 pl-3 text-xs md:text-md">
        </div>
      
    </div>

    </div>

    <div class="mt-8 flex justify-start w-full ml-0 md:ml-0.5">
      <button mat-raised-button 
        class="w-full md:w-40 rounded-md font-bold h-12" 
        (click)="actualizarProcedencia()">Guardar</button>
    </div>
    
</div>
}